import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {
    GetBuyerImplementationPrimaryContactResponse,
    GetBuyerImplementationPrimaryContactService
} from '@lsq-frontend/remote-services/all-java/financing-mk2-services/operations/admin-manage-buyer-implementation/get-buyer-implementation-primary-contact';
import {
    forLifeOf,
    getDynamicRouterLink,
    getRouterLinkById,
    LifecycleAware
} from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { ADMIN_MANAGE_BUYER_CONTACT, atlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { ManageBuyerService } from '../manage-buyer.service';

@Component({
    selector: 'review-buyer-company-contact',
    styleUrls: ['./review-buyer-section.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
        <buyer-review-section
            [sectionTitle]="'Primary Contact'"
            [editLocation]="editLocationUrl$ | async"
        >
            <div card-body *ngIf="!cachedResponse">
                <lsq-circle-loader></lsq-circle-loader>
            </div>
            <div *ngIf="cachedResponse" class="review-buyer-section">
                <info-box
                    *ngIf="
                        !cachedResponse.primaryContactFirstName ||
                        !cachedResponse.primaryContactLastName ||
                        !cachedResponse.primaryContactEmail
                    "
                >
                    You have missing information that needs your attention.
                </info-box>
                <div [style.padding]="'2rem 3rem'">
                    <p class="body" [style.marginBottom]="'2rem'">
                        The Primary Contact will receive an invite to create their FastTrack account
                        once buyer implementation is complete.
                    </p>
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <p class="label">
                                Full Name
                                <lsq-icon
                                    id="primaryContactFullNameWarning"
                                    *ngIf="
                                        !cachedResponse.primaryContactFirstName ||
                                        !cachedResponse.primaryContactLastName
                                    "
                                    [type]="icons.FaExclamationTriangleSolid"
                                ></lsq-icon>
                            </p>
                            <p class="body text-dark-gray" id="primaryContactFullName">
                                {{
                                    !cachedResponse.primaryContactFirstName ||
                                    !cachedResponse.primaryContactLastName
                                        ? '—'
                                        : cachedResponse.primaryContactFirstName +
                                          ' ' +
                                          cachedResponse.primaryContactLastName
                                }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-6">
                            <p class="label">
                                Email
                                <lsq-icon
                                    id="primaryContactEmailWarning"
                                    *ngIf="!cachedResponse.primaryContactEmail"
                                    [type]="icons.FaExclamationTriangleSolid"
                                ></lsq-icon>
                            </p>

                            <p class="body text-dark-gray" id="primaryContactEmail">
                                {{
                                    !cachedResponse.primaryContactEmail
                                        ? '—'
                                        : cachedResponse.primaryContactEmail
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </buyer-review-section>
    `
})
@LifecycleAware()
export class ReviewBuyerCompanyContactComponent implements OnInit {
    @Output() public completed = new EventEmitter<boolean>();

    private _fetchSubject = new Subject();

    public cachedResponse: GetBuyerImplementationPrimaryContactResponse;
    public icons = Icons;

    public editLocationUrl$: Observable<UrlTree>;
    constructor(
        private _getBuyerImplementationPrimaryContactService: GetBuyerImplementationPrimaryContactService,
        private _manageBuyerService: ManageBuyerService,
        private _router: Router
    ) {}

    public ngOnInit(): void {
        combineLatest([
            this._manageBuyerService.buyerKey$,
            this._fetchSubject.pipe(startWith(true))
        ])
            .pipe(
                forLifeOf(this),
                filter((buyerKey) => !!buyerKey)
            )
            .subscribe(async ([buyerKey, _]) => {
                if (buyerKey) {
                    this.cachedResponse = await this._getBuyerImplementationPrimaryContactService.executeOnce(
                        {
                            buyerImplementationKey: buyerKey
                        }
                    );
                }

                this.completed.emit(
                    !!this.cachedResponse.primaryContactFirstName &&
                        !!this.cachedResponse.primaryContactLastName &&
                        !!this.cachedResponse.primaryContactEmail
                );
            });

        this.editLocationUrl$ = this._manageBuyerService.buyerKey$.pipe(
            map((buyerKey) => {
                const urlTree = this._router.createUrlTree(
                    getDynamicRouterLink(
                        getRouterLinkById(atlas, ADMIN_MANAGE_BUYER_CONTACT, {
                            noStandaloneLeadingSlash: true
                        }),
                        { buyerKey }
                    ),
                    {
                        queryParams: {
                            isImplementation: true
                        }
                    }
                );
                return urlTree;
            })
        );
    }
}
